import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { ModalService } from "@core-services/modal.service";
import { SendTransaction } from "@models/transaction";
import { PaymentsCryptocoin } from "@modules/+new/payments/shared-payments/entities/payments-cryptocoin.model";
import { Network } from "@modules/+new/payments/features/crypto-deposit/domain/entities/network.model";
import { MultichainSendService } from "@modules/main/components/step-summary/sending-modal/services/multichain-send.service";

@Component({
	selector: "app-send-multichain-two-fa",
	templateUrl: "./send-multichain-two-fa.component.html",
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [MultichainSendService],
	standalone: false
})
export class SendMultichainTwoFaComponent {
	@Input() sendTransaction: SendTransaction = null;
	@Input() selectedCryptocoin: PaymentsCryptocoin = null;
	@Input() selectedNetwork: Network = null;
	@Input() walletId: string = "";
	@Input() onBehalfOf: string = "";

	constructor(
		private readonly modalService: ModalService,
		private readonly multichainSendService: MultichainSendService
	) {}

	public onBackButtonClick(): void {
		this.modalService.pop();
	}

	public onCancelButtonClick(): void {
		this.modalService.popAll();
	}

	public save(authCode: string): void {
		this.sendTransaction.authCode = authCode;
		this.multichainSendService.finishTravelRuleWithdrawal(
			this.sendTransaction.getAddressBookWalletId(),
			this.sendTransaction.getAmountCoin(),
			this.walletId,
			this.selectedNetwork,
			this.selectedCryptocoin,
			this.onBehalfOf,
			authCode
		);
	}
}
